<template>
  <div class="index">
    <a class="img" v-for="item in list" :href="item.link" :style="{backgroundColor: item.color}" v-lazy:background-image="item.img" target="_blank"></a>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        list: [{
          color: '#7e6d53',
          // link: 'https://mybank.icbc.com.cn/icbc/newperbank/bankbook/bankbook_onlineapply_mid.jsp?firstPage=111&corpCode=HZDW000007461&promoCode=HW88802001587429641',
          // img: '//sr-img.oss-cn-beijing.aliyuncs.com/OSS/2018/03/07/f33ef2a8-8b9e-48f3-a829-5d7a890eb231.jpeg',
          link: 'https://m2.ylzxvip.com/profile?origin=main-pc/#/index/restaurant',
          img: '//sr-img.oss-cn-beijing.aliyuncs.com/OSS/2018/04/25/2d4301be-20f5-42b3-9386-9a957bad93ae.jpg'
        }, {
          color: '#7d502f',
          img: '//sr-img.oss-cn-beijing.aliyuncs.com/OSS/2017/12/15/19a48c3d-d9eb-421c-a772-4a297ec1eddf.jpg'
        }, {
          color: '#293c4b',
          img: '//sr-img.oss-cn-beijing.aliyuncs.com/OSS/2017/12/15/3351ffb8-c8e0-45ef-ad17-d70a80a44ab4.jpg'
        }, {
          color: '#7e6d53',
          img: '//sr-img.oss-cn-beijing.aliyuncs.com/OSS/2017/12/15/6da5fc1b-dc2f-4c96-9956-816580ba7070.jpg'
        }]
      }
    }
  }
</script>

<style lang="less" scoped>
  .index {
    .img {
      display: block;
      padding-top: 39%;
      background-size: cover;
      background-position: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue